import * as React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { CodetableItemProps } from './types';
import styles from './codetable-item.scss';
import { CodetableItemRow } from 'app/area/import-mappings/list-items/common/codetable-item-row';
import { CodetableItemContent } from 'app/area/import-mappings/list-items/codetable-item-content';

export class CodetableItem extends React.PureComponent<CodetableItemProps> {

  private onExpand = () => {
    const { codeItem, expandCodeItem } = this.props;

    expandCodeItem(codeItem.id);
  };

  public render() {

    const { isZebra, refetching, open, isHierarchyMode, hierarchyMetadata, isCodetableWithCategory, currentCode, modifiedItems,
      codeItem, updating, translation, treeDepthLevel, validation, setCurrentCode, clearValidation } = this.props;

    const shouldShowZebra = isZebra;

    const codeItemHierarchyMetadata = hierarchyMetadata.find(metadata => metadata.depthLevel === treeDepthLevel);

    const hasChildren = !!codeItemHierarchyMetadata ? codeItemHierarchyMetadata.hasChildren : undefined;

    const selected = codeItem?.id === currentCode?.id;

    return <CodetableItemRow
      isZebra={shouldShowZebra}
      isSelected={selected}
      treeDepthLevel={treeDepthLevel}>
      {
        isHierarchyMode
          ? <div className={styles.expanderButtonContainer}>
            <button
              type="button"
              className={`${isZebra ? styles.zebra : ''} ${styles.expanderButton} 
              ${open ? styles.open : ''} ${!hasChildren ? styles.hidden : ''} `}
              onClick={this.onExpand}>
              <FiChevronDown />
            </button>
          </div>
          : null
      }
      <CodetableItemContent
        currentCode={currentCode}
        codeItem={codeItem}
        isHierarchyMode={isHierarchyMode}
        isCodetableWithCategory={isCodetableWithCategory}
        refetching={refetching}
        setCurrentCode={setCurrentCode}
        clearValidation={clearValidation}
        treeDepthLevel={treeDepthLevel}
        hierarchyMetadata={hierarchyMetadata}
        modifiedItems={modifiedItems}
        updating={updating}
        validation={validation}
        translation={translation} />
    </CodetableItemRow>;
  }
}
